import { SimpleGrid, Checkbox, Group, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { Indicator } from 'utils/models';
import { displayFormError } from 'utils/validation';
import { defaultMeasurementIndicators, getHeartRhythmIndicatorLabel } from 'utils/measurement';
import { RuleReportGenerations } from 'models/rules';
import { snakeCase } from 'lodash';

export const ReportGeneratedFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors, setFieldValue } = useCreateRuleFormContext();

  const indicators = [Indicator.Normal, ...defaultMeasurementIndicators.filter((i) => i !== Indicator.Normal)]; // Ensure 'Normal' is first
  const dataField = 'data.summaryReportGenerated';

  const renderIndicatorLabels = () => (
    <SimpleGrid cols={2} verticalSpacing={'xs'} mb={'xs'}>
      {indicators.map((indicator) => (
        <Checkbox
          key={indicator}
          value={indicator}
          label={getHeartRhythmIndicatorLabel(indicator)}
          disabled={values.formDisabled}
        />
      ))}
    </SimpleGrid>
  );

  const handleTriggerChange = (value: string | null) => {
    if (!value) return;
    setFieldValue('trigger', value);
    setFieldValue(`${dataField}.indicator`, undefined);
    setFieldValue(`${dataField}.isEmpty`, undefined);
  };

  return (
    <>
      <Group justify={'flex-start'}>
        <Select
          label={t('report_type_label')}
          data={Object.values(RuleReportGenerations).map((value) => ({
            value,
            label: t(`${snakeCase(value)}_label`),
          }))}
          placeholder={t('select_report_type_label')}
          {...getInputProps('trigger')}
          onChange={handleTriggerChange}
          disabled={values.formDisabled}
        />
      </Group>
      {values.trigger === RuleReportGenerations.summary && (
        <Group align={'top'}>
          <Checkbox.Group
            label={t('summary_report_types_label')}
            {...getInputProps(`${dataField}.indicator`)}
            error={displayFormError({ errors, dataField: `${dataField}.indicator`, label: t('empty_value_select') })}
          >
            {renderIndicatorLabels()}
          </Checkbox.Group>
          <Checkbox
            mt={25}
            {...getInputProps(`${dataField}.isEmpty`, { type: 'checkbox' })}
            label={t('empty_label')}
            disabled={values.formDisabled}
          />
        </Group>
      )}
    </>
  );
};
